import { CnDatePickerPro as UiCnDatePickerPro, CnWeekPickerPro as UiCnWeekPickerPro, CnMonthPickerPro as UiCnMonthPickerPro, CnYearPickerPro as UiCnYearPickerPro, } from '@/components/cn-date-picker-pro';
import { connect, mapProps } from '@formily/react';
import { mapSize, mapStatus } from '../__builtins__';
export var CnDatePickerPro = connect(UiCnDatePickerPro, mapProps(mapSize, mapStatus));
export var CnWeekPickerPro = connect(UiCnWeekPickerPro, mapProps(mapSize, mapStatus));
export var CnMonthPickerPro = connect(UiCnMonthPickerPro, mapProps(mapSize, mapStatus));
export var CnYearPickerPro = connect(UiCnYearPickerPro, mapProps(mapSize, mapStatus));
